import React, { useEffect, useState } from 'react';
import { Smartphone, Send, Loader2, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { adminApi } from '../../lib/programsApi';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : '—');

// "Send test push to me" — reaches ONLY the signed-in admin's registered devices. Never a broadcast.
export const PushTestPanel = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const load = () => adminApi.pushAdminDevices().then(setD).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);
  const send = async () => {
    setBusy(true);
    try { const r = await adminApi.pushAdminTest('launch'); setResult(r); toast.success(`Test push sent to ${r.sent}/${r.total} of your devices`); load(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-stone-200 bg-white p-3 space-y-2" data-testid="push-test-panel">
      <div className="flex flex-wrap items-center gap-2">
        <Smartphone className="w-4 h-4 text-[#C79A4A]" />
        <p className="text-sm font-semibold text-stone-800 flex-1">Personal push test</p>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 font-semibold inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Admin devices only</span>
      </div>
      {!d ? <p className="text-xs text-stone-500">Loading…</p> : (
        <>
          <p className="text-xs text-stone-700" data-testid="push-test-devices">
            Your account has <b>{d.devices}</b> device{d.devices === 1 ? '' : 's'} with notifications enabled{d.lastRegisteredAt ? ` · last registered ${fmt(d.lastRegisteredAt)}` : ''}.
            {' '}<span className="text-stone-500">{d.optedInMembers} member{d.optedInMembers === 1 ? '' : 's'} opted in overall.</span>
          </p>
          {d.devices === 0 && <p className="text-[11px] text-amber-700 font-semibold" data-testid="push-test-no-devices">Enable notifications on your phone first: Profile → Notifications → “Turn on notifications”. On iPhone, add Reflections to your Home Screen first.</p>}
          <button type="button" disabled={busy || d.devices === 0} onClick={send} className="h-9 px-4 rounded-full bg-[#173F35] text-white text-xs font-semibold inline-flex items-center gap-1.5 disabled:opacity-40" data-testid="push-test-send">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} Send test push to me
          </button>
          {(result || d.lastTest) && <p className="text-[11px] text-stone-500" data-testid="push-test-result">Last test: {result ? `${result.sent}/${result.total} delivered · just now` : `${d.lastTest.meta?.sent}/${d.lastTest.meta?.devices} delivered · ${fmt(d.lastTest.createdAt)}`}</p>}
          <p className="text-[10.5px] text-stone-400">Nothing is ever sent to members from here. Mass sends live below and require your explicit launch confirmation.</p>
        </>
      )}
    </div>
  );
};
